module.exports = __webpack_public_path__ + "static/media/mf.10d7fbfd.svg";